export enum LoanTransactionDetailId {
	PAYMENT_INTEREST = 10,
	PAYMENT_PRINCIPAL = 11,
	PAYMENT_FEES = 12,
	PAYMENT_PRINCIPAL_ADDITIONAL = 19,
	PAYMENT_CHARGE_OFF_BALANCE = 20,
	UNPAID_INTEREST = 30,
	NON_LOAN_ITEMS = 40,
	SCRA_INTEREST_REFUND = 98,
	OVERPAYMENT = 99,
}
